import { Switch } from "../switch";

/** BOOLEAN field — full-width align so the switch lives in the
 *  field-row rhythm instead of the SettingsRow rhythm (those two have
 *  different visual weights). Stored as the string `"true"`/`"false"`
 *  per the BE's wire contract. */
export function BooleanControl({
  id,
  value,
  disabled,
  onChange,
}: {
  id: string;
  value: string | null;
  disabled?: boolean;
  onChange: (next: string | null) => void;
}) {
  // Render inside a flex container so the switch hugs the start —
  // matches the other field controls' left-alignment instead of
  // stretching to full-width-blank.
  return (
    <div className="flex">
      <Switch
        id={id}
        checked={value === "true"}
        disabled={disabled}
        onChange={(next) => onChange(next ? "true" : "false")}
      />
    </div>
  );
}
